import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section className="py-20 md:py-24 bg-gradient-to-b from-cyan-50/60 to-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center">
          <h2 className="font-heading font-bold text-slate-900 text-3xl md:text-4xl">What Our Clients Say</h2>
          <p className="mt-3 text-slate-500 text-lg">Don't just take our word for it</p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-white border border-slate-100 rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={18} className="fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="mt-5 text-slate-600 italic leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 pt-5 border-t border-slate-100">
                <div className="font-heading font-semibold text-slate-900">{t.name}</div>
                <div className="text-slate-400 text-sm">{t.company}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
